import { enGB, fr } from "date-fns/locale";
import en from "../i18n/en.json";

const KEY = "logidem-lang";
const ATTRS = ["placeholder", "title", "aria-label", "alt"];

const PUB_RE = /^\/(devis-client|facture-client|signature|avis)\/|^\/app\/devis\/[^/]+\/imprimer/;
export const langOverridden = () => PUB_RE.test(window.location.pathname) && !!sessionStorage.getItem(KEY);

export const getLang = () => {
  const url = new URLSearchParams(window.location.search).get("lang");
  if (url === "en" || url === "fr") sessionStorage.setItem(KEY, url);
  const pub = langOverridden() && sessionStorage.getItem(KEY);
  return (pub || localStorage.getItem(KEY)) === "en" ? "en" : "fr";
};
export const dateLocale = () => (getLang() === "en" ? "en-GB" : "fr-FR");
export const dfLocale = getLang() === "en" ? enGB : fr;

export const setLang = (lang, reload = true) => {
  localStorage.setItem(KEY, lang);
  if (reload) window.location.reload();
};

const exact = new Map(Object.entries(en.exact || {}));
const patterns = (en.patterns || []).map(([src, rep]) => [new RegExp(`^${src}$`), rep]);

export function translate(s) {
  const t = s.trim();
  if (!t) return null;
  let v = exact.get(t);
  if (v === undefined) {
    for (const [re, rep] of patterns) {
      const m = t.match(re);
      if (m) {
        v = rep.replace(/\$(\d)/g, (_, i) => exact.get((m[i] || "").trim()) ?? m[i] ?? "");
        break;
      }
    }
  }
  return v === undefined ? null : s.replace(t, v);
}

function walk(node) {
  if (node.nodeType === 3) {
    const v = translate(node.nodeValue);
    if (v !== null && v !== node.nodeValue) node.nodeValue = v;
    return;
  }
  if (node.nodeType !== 1 || node.tagName === "SCRIPT" || node.tagName === "STYLE") return;
  ATTRS.forEach((a) => {
    const x = node.getAttribute(a);
    const v = x && translate(x);
    if (v && v !== x) node.setAttribute(a, v);
  });
  if (node.tagName !== "TEXTAREA") node.childNodes.forEach(walk);
}

export function startI18n() {
  if (getLang() !== "en") return;
  document.documentElement.lang = "en";
  const confirm = window.confirm.bind(window);
  window.confirm = (msg) => confirm(translate(String(msg)) || msg);
  new MutationObserver((muts) => {
    muts.forEach((m) => {
      if (m.type === "childList") m.addedNodes.forEach(walk);
      else walk(m.target);
    });
  }).observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ATTRS });
  walk(document.body);
  document.title = translate(document.title) || document.title;
}
